import React, { FC } from 'react';
import * as Styled from './Separator.styled';

export const Separator: FC = () => {
  return <Styled.Separator />;
};
